import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import { ADMIN_PAGE_SX } from "./adminStyles";

const AdminPage = ({
  title,
  subtitle,
  actions,
  error,
  onDismissError,
  children,
}) => (
  <Box sx={ADMIN_PAGE_SX}>
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", md: "center" }}
      spacing={2}
      sx={{ mb: 2 }}
    >
      <Box>
        <Typography variant="h4" fontWeight={900}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions ? (
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{ flexWrap: "wrap", rowGap: 1 }}
        >
          {actions}
        </Stack>
      ) : null}
    </Stack>
    {error && (
      <Alert severity="error" onClose={onDismissError} sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    {children}
  </Box>
);

export default AdminPage;
